import { ReactNode, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PlusIcon } from "@heroicons/react/24/outline";
import cn from "classnames";
import Button from "../common/Button";
import NewRequestModal from "./NewRequestModal";

const TABS: { path: string; label: string }[] = [
  { path: "/feature-requests", label: "Requests" },
  { path: "/feature-requests/roadmap", label: "Roadmap" },
  { path: "/feature-requests/changelog", label: "Changelog" },
];

// Header + tab strip shared by the board, roadmap, and changelog views.
// The New request modal lives here so every tab can open it.
const BoardLayout: React.FC<{ children: ReactNode; subtitle?: string }> = ({ children, subtitle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [creating, setCreating] = useState(false);

  return (
    <div className="flex-1 overflow-auto p-6 space-y-6">
      {/* No wrap: the title block shrinks and the subtitle wraps so the button
          stays on the right at every width and zoom. */}
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <h1 className="text-3xl font-semibold">Feature Requests</h1>
          <p className="text-base-content/60 text-sm mt-1">{subtitle || "Tell us what would make your job easier, and vote on what other officers have asked for."}</p>
        </div>
        <Button variant="primary" className="shrink-0 px-4 whitespace-nowrap" onClick={() => setCreating(true)}>
          <PlusIcon className="h-5 w-5" /> New request
        </Button>
      </div>
      {/* Same tab strip as InvestigationDetail: plain buttons on a 2px
          underline, blue when active. */}
      <div className="border-b border-base-300 -mt-2">
        <nav className="flex gap-0 -mb-px overflow-x-auto">
          {TABS.map((t) => (
            <button
              key={t.path}
              type="button"
              onClick={() => navigate(t.path)}
              className={cn(
                "relative px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors",
                location.pathname === t.path
                  ? "border-blue-500 text-blue-600 dark:text-blue-300"
                  : "border-transparent text-base-content/60 hover:text-base-content/80 hover:border-base-content/30"
              )}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>
      {children}
      <NewRequestModal open={creating} onClose={() => setCreating(false)} onCreated={(item) => navigate(`/feature-requests/${item.id}`)} />
    </div>
  );
};

export default BoardLayout;
